module.exports = __webpack_public_path__ + "img/md_close.0e91f966.svg";